<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card :class="{active}" :ripple="{ class: 'text--gray-400' }" flat>
        <v-overlay :absolute="true" :value="hover" color="primary">
          <Loader :yes="loading" color="white"/>
        </v-overlay>

        <v-overlay :absolute="true" :value="error" color="primary">
          {{ t({s: 'sidebar.error.noMarkers', component: 'Map'}) }}
        </v-overlay>

        <v-layout align-center class="px-3 py-1">
          <v-flex>
            <v-img contain src="/img/markers/end.png" width="25"></v-img>
          </v-flex>
          <v-flex>
            <v-label v-if="trip.trip_ended_at">{{ endedAt.format('HH:mm') }}</v-label>
          </v-flex>
          <v-flex xs9>
            <v-subheader>{{ trip && trip.end_address }}</v-subheader>
          </v-flex>
        </v-layout>
        <v-layout align-center class="px-3 py-1">
          <v-flex>
            <v-img contain src="/img/markers/start.png" width="25"></v-img>
          </v-flex>
          <v-flex>
            <v-label v-if="trip.trip_started_at">{{ startedAt.format('HH:mm') }}</v-label>
          </v-flex>
          <v-flex xs9>
            <v-subheader>{{ trip && trip.start_address }}</v-subheader>
          </v-flex>
        </v-layout>
        <v-subheader>
          <v-layout style="padding: 0 !important;">
            <v-flex>
              <v-icon :size="12.5" class="mr-1">fal fa-arrows-h</v-icon>
              <span class="mr-3">{{ distance }} km</span>
            </v-flex>
            <v-flex>
              <v-icon :size="12.5" class="mr-1">fal fa-tachometer-average</v-icon>
              <span class="mr-3">{{ speed }} km/h</span>
            </v-flex>
              <v-flex v-if="trip.max_speed !== 0">
                <v-icon :size="12.5" class="mr-1">fal fa-tachometer-fastest</v-icon>
                <span class="mr-3">{{ trip.max_speed }} km/h</span>
              </v-flex>
            <v-flex>
              <v-icon :size="12.5" class="mr-1">fal fa-clock</v-icon>
              <span>{{ duration }}</span>
            </v-flex>
          </v-layout>
        </v-subheader>
        <v-divider></v-divider>
      </v-card>
    </template>
  </v-hover>
</template>

<script lang="js" type="es6">
import { mapState } from 'vuex'
import Loader from '@/components/Global/Loader'
import {convertUtcDateToPoint} from "@/helpers/general"

export default {
  name: 'Trips',
  components: { Loader },
  props: ['trip', 'loading', 'active', 'error'],
  data () {
    return {
      address: null,
      points: null,
      overlay: false
    }
  },
  computed: {
    ...mapState(['user', 'timezone']),
    startedAt () {
      let date = null
      if (this.trip && this.trip.trip_started_at) {
        date = this.trip.trip_started_at
      }

      return convertUtcDateToPoint(date, [this.trip.start_position.longitude, this.trip.start_position.latitude])
    },
    endedAt () {
      let date = null
      if (this.trip && this.trip.trip_ended_at) {
        date = this.trip.trip_ended_at
      }

      return convertUtcDateToPoint(date, [this.trip.end_position.longitude, this.trip.end_position.latitude])
    },
    endDate () {
      if (this.trip) {
        return this.endedAt
      }

      return '--:--'
    },
    startDate () {
      if (this.trip) {
        return this.trip.endedAt
      }

      return '--:--'
    },
    distance () {
      return this.trip?.distance ? Math.round((this.trip.distance / 1000) * 100) / 100 : 0.00 || 0.00
    },
    duration () {
      if (this.trip) {
        const duration = this.$moment(this.trip.trip_ended_at).diff(this.trip.trip_started_at, 'seconds')

        return this.trip.duration > duration ? this.hhmmss(duration) : this.hhmmss(this.trip.duration)
      } else {
        return undefined
      }
    },
    speed () {
      return this.trip?.average_speed ? Math.round(this.trip.average_speed * 10) / 10 : 0.0 || 0.0
    }
  }
}
</script>

<style scoped>
.v-chip.primary {
  background-color: rgba(17, 45, 71, 0.9) !important;
}

.v-card {
 cursor: pointer !important;
}

.v-card__title:after {
  content: '';
  position: absolute;
  z-index: 0;
  left: 10%;
  right: 10%;
  height: 0;
  width: 80%;
  border-bottom: thin dashed rgba(201, 114, 0, 0.5);
}

.inactive {
  background-color: rgba(90, 100, 110, 0);
  transition: ease all 0.3s;
}

.active {
  background-color: rgba(90, 100, 110, 0.25) !important;
  transition: ease all 0.3s;
}

.v-card__title span {
  z-index: 1;
  padding: 0.1em 0.3em;
  background-color: white;
  font-size: 0.75em;
  font-weight: normal;
}
</style>
